import {
  Card,
  CardContent,
  Checkbox,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import { ListSettings } from "@saleor/types";
import React from "react";

import DropOffSearchFilter from "../DropOffSearchFilter";
import DropOffSearchInput from "../DropOffSearchInput";
import DropOffTablePagination from "../DropOffTablePagination";

export interface DropOffTaskAreaAvailableStoresProps {
  availableStores: any[];
  setAvailableStores: React.Dispatch<React.SetStateAction<any[]>>;

  tenantsLoading: boolean;
  searchAvailableStores: string;
  onSearchChangeAvailableStores: (text: string) => void;
  onFilterChangeAvailableStores: (index: number) => void;

  isSelectAllAvailableStores: boolean;
  clickSelectAllAvailableStores: () => void;

  pageInfo: any;
  settings: ListSettings<string>;
  updateListSettings: (key: keyof ListSettings<any>, value: any) => void;
  onLoadNextPage: () => void;
  onLoadPreviousPage: () => void;
}

const DropOffTaskAreaAvailableStores: React.FC<DropOffTaskAreaAvailableStoresProps> = props => {
  const {
    availableStores,
    setAvailableStores,
    tenantsLoading,
    searchAvailableStores,
    onSearchChangeAvailableStores,
    onFilterChangeAvailableStores,
    isSelectAllAvailableStores,
    clickSelectAllAvailableStores,
    pageInfo,
    settings,
    updateListSettings,
    onLoadNextPage,
    onLoadPreviousPage
  } = props;

  const classes = useTemplateStyles(props);

  const options = ["All", "Food & Beverages", "General Merchandise"];

  return (
    <Grid item xs={5}>
      <div
        className={`${classes.displayFlexCenterSpaceBetween} ${classes.assignStoreSearchFilter}`}
      >
        <div className={classes.div100}>
          <DropOffSearchInput
            key="dropOffAssignTASearchAvailableStores"
            initialSearch={searchAvailableStores}
            placeholder="Search Available Stores"
            onSearchChange={onSearchChangeAvailableStores}
          />
        </div>
        <div className={classes.textMarginLeft}>
          <DropOffSearchFilter
            keyId="dropOffAssignTAFilterAvailableStores"
            options={options}
            handleChange={onFilterChangeAvailableStores}
          />
        </div>
      </div>

      {tenantsLoading ? (
        <Card className={classes.taskAreaCard}>
          <div className={classes.divFlexCentered100}>
            <span className={classes.textPrimary}>
              Loading Available Stores...
            </span>
          </div>
        </Card>
      ) : (
        <Card className={classes.taskAreaCard}>
          <CardTitle title={null}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              className={classes.cardTitleContainer}
            >
              <Grid item>
                <span className={classes.cardTitle}>Select All</span>
              </Grid>
              <Grid item>
                <Checkbox
                  disabled={availableStores.length === 0}
                  onChange={() => clickSelectAllAvailableStores()}
                  checked={isSelectAllAvailableStores}
                  tabIndex={-1}
                  disableRipple
                />
              </Grid>
            </Grid>
          </CardTitle>
          <CardContent className={classes.taskAreaCardContent}>
            <List dense component="div" role="ul" key={"availableStores"}>
              {availableStores.map(tenant => (
                <ListItem
                  key={"available-" + tenant?.tenantId}
                  role="li"
                  button
                  onClick={() => {
                    const newState = availableStores.map(obj => {
                      if (obj.tenantId === tenant.tenantId) {
                        return { ...obj, isChecked: !obj.isChecked };
                      }
                      return obj;
                    });

                    setAvailableStores(newState);
                  }}
                >
                  <ListItemText primary={tenant.storeName} />
                  <ListItemIcon className={classes.cardCheckbox}>
                    <Checkbox
                      className={classes.cardCheckbox}
                      checked={tenant.isChecked}
                      disableRipple
                    />
                  </ListItemIcon>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      )}

      <DropOffTablePagination
        settings={settings}
        onUpdateListSettings={updateListSettings}
        hasNextPage={pageInfo && !tenantsLoading ? pageInfo.hasNextPage : false}
        onNextPage={onLoadNextPage}
        hasPreviousPage={
          pageInfo && !tenantsLoading ? pageInfo.hasPreviousPage : false
        }
        onPreviousPage={onLoadPreviousPage}
      />
    </Grid>
  );
};

DropOffTaskAreaAvailableStores.displayName = "DropOffTaskAreaAvailableStores";
export default DropOffTaskAreaAvailableStores;
